'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var utils = require('../../utils');

var errcode = require('err-code');
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('../../message')} Message
 */

/**
 * @param {import('../../index')} dht
 */


module.exports = function (dht) {
  var log = utils.logger(dht.peerId, 'rpc:put-value');
  /**
   * Process `PutValue` DHT messages.
   *
   * @param {PeerId} peerId
   * @param {Message} msg
   */

  function putValue(_x, _x2) {
    return _putValue.apply(this, arguments);
  }

  function _putValue() {
    _putValue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peerId, msg) {
      var key, record, errMsg, recordKey;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              key = msg.key;
              log('key: %b', key);
              record = msg.record;

              if (record) {
                _context.next = 7;
                break;
              }

              errMsg = "Empty record from: ".concat(peerId.toB58String());
              log.error(errMsg);
              throw errcode(new Error(errMsg), 'ERR_EMPTY_RECORD');

            case 7:
              _context.next = 9;
              return dht._verifyRecordLocally(record);

            case 9:
              record.timeReceived = new Date();
              recordKey = utils.bufferToKey(record.key);
              _context.next = 13;
              return dht.datastore.put(recordKey, record.serialize());

            case 13:
              dht.onPut(record, peerId);
              return _context.abrupt("return", msg);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _putValue.apply(this, arguments);
  }

  return putValue;
};